document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll("video.lazy-autoplay");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
          video.currentTime = 0; // Redémarre à 0 si non visible
        }
      });
    },
    {
      threshold: 0.6, // Joue quand 60% de la vidéo est visible
    }
  );

  videos.forEach((video) => {
    observer.observe(video);
  });
});